import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReplyIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M7.5 6.75v-3L2.25 9l5.25 5.25v-3.075c3.75 0 6.375 1.2 8.25 3.825-.75-3.75-3-7.5-8.25-8.25Z" />
  </Icon>
);

export default memo(ReplyIcon);
